var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc112(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.845mm",
    height: "10.6283mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 959.63 940.45",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465261581328"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M538.46 773.75l-363.34 -364.27 14.05 -14.05 364.27 364.51 -14.99 13.81 0.01 0zm234.11 -1.17l-599.8 -603.78 14.51 -13.81 598.63 603.08 -13.34 14.51 0 0.01z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2464996291040"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M785.92 940.45l-785.92 0 0 -785.92 187.29 0 2.57 243.48 -2.57 360.77 598.63 0 0 181.67 0 0.01zm-766.25 -19.66l746.35 0 0 -142.11 -598.39 0 2.34 -380.67 -2.11 -223.82 -148.2 0 0 746.59 0.01 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M959.63 236.46c0,-130.6 -105.86,-236.46 -236.46,-236.46 -130.6,0 -236.46,105.86 -236.46,236.46 0,130.6 105.86,236.46 236.46,236.46 130.6,0 236.46,-105.86 236.46,-236.46zm-206.95 -127.12l0 101.37 98.33 0 0 51.04 -98.33 0 0 100.44 -56.42 -0.02 0 -100.68 -97.63 0 0 -50.81 97.63 0 0 -101.37 56.42 0 0 0.03z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc112);
export default __webpack_public_path__ + "static/media/ic_1_12.8ee42ab6e603fbf6f35ef16c993fb43f.svg";
export { ForwardRef as ReactComponent };